"use client";
import React from 'react';
import './FormStep3.css';
import PropTypes from 'prop-types';
import { Input } from 'atm-global-stylish/dist';
import PhoneInput from '../basic/PhoneInput/PhoneInput';
import { INPUT_CLASSNAME } from '../../config/constants';

const ThingsStep3 = ({errors, formData, handleChange }) => {
	return (
		<div className='w-full'>
			
			<div className='w-full flex flex-col gap-5 my-4'>
				<h2 className='text-xl text-red font-semibold my-4 w-full text-center'>Datos personales del dueño del inmueble</h2>
				<div className='flex flex-row w-full justify-between gap-10'>
					<Input type='text' value={formData.owner_vehicle_name} handleChange={handleChange('owner_vehicle_name')} placeholder='Nombre y Apellido / RAZON SOCIAL' className={`${!errors.owner_vehicle_name ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={50} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
					<Input
						type='number'
						value={formData.owner_vehicle_cuit}
						maxLength={11}
						handleChange={(e) => {
                    		const onlyNumbers = e.target.value.replace(/\D/g, '');

							if (onlyNumbers.length <= 11)
								handleChange('owner_vehicle_cuit')({ target: { value: onlyNumbers } })
							else
								return
						}}
						placeholder='CUIT / CUIL / DNI'
						className={`${!errors.owner_vehicle_cuit ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`}
					/>
				</div>
				<div className='flex flex-row w-full justify-between gap-10'>
					<Input type='text' value={formData.owner_vehicle_address} handleChange={handleChange('owner_vehicle_address')} placeholder='Domicilio' className={`${!errors.owner_vehicle_address ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={50} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
					<PhoneInput
						handleChange={handleChange}
						prefix={'owner_vehicle_'}
						className={`${!errors.owner_vehicle_phone ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`}
					/>
				</div>
				
				<div className='flex flex-row w-1/2 justify-between gap-10'>
					<Input type='email' value={formData.owner_vehicle_mail} handleChange={handleChange('owner_vehicle_mail')} placeholder='Correo Electronico' className={`${!errors.owner_vehicle_mail ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={100} regex={/^[a-zA-Z0-9@._\-,]*$/} />
				</div>
				
				
			</div>
			{Object.keys(errors).length > 0 && (
				<p className="text-pink text-sm text-center mb-4">(*) Los campos marcados son obligatorios.</p>
			)}
 		</div>
	);
};

ThingsStep3.propTypes = {
	errors: PropTypes.object,
	formData: PropTypes.object,
	handleChange: PropTypes.func,
	type: PropTypes.string
};

export default ThingsStep3;